import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  IconButton,
  Select,
  ListItemText,
  MenuItem,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button';

import * as api from '../../../services/api/admin';
import Backgroundscroll from '../../../Backgroundscroll';

function ProfileEditModal(props) {
  const {
    providersContents,
    openEditModal,
    open,
    onClose,
    setOpenEditModal,
    availableSections,

    classes: {
      modal,
      modalContent,
      contentCard,
      innerPadding,
      selectFormatting,
      fontAdjust,
    },
  } = props;

  const [editOrder, setEditOrder] = useState([]);


  let updatedOrder;

  const updateOrder = () => {
    setEditOrder(updatedOrder);
  };

  const updateAll = () => {
    editOrder.forEach(async item => {
      await api.updateProfileContent(item);
    });

    onClose();


  };

  const onDelete = async id => {
    try {
      await api.deleteProfileContent(id);
      const updatedContents = providersContents.filter(item => item.id !== id);
      props.setProvidersContents(updatedContents);
    } catch (err) {
      console.log(err);
    }
    onClose();
  };

  const handleOrderChange = e => {
    updatedOrder = [...providersContents];
    e.preventDefault();

    updatedOrder[e.target.dataset.idx]['sectionOrder'] = parseInt(
      e.target.value
    );


  };

  useEffect(() => {
    (async () => {
      let fields = document.getElementsByTagName('input'),
        length = fields.length;
      while (length--) {
        if (fields[length].type === 'text') { fields[length].value = ''; }
      }
    })();
  }, [editOrder]);


  return (
    <Dialog fullWidth open={open} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11} className="headingSize">
            <h2>Edit content</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: modalContent }}>
        <Grid className={selectFormatting}>
          <Select
            fullWidth
            variant="outlined"
            label="Section"
            name="section"
            value={openEditModal.section}
            onChange={event => {
              setOpenEditModal({ section: event.target.value, bool: true });
            }}
          >
            {availableSections.map(section => (
              <MenuItem key={`menu-${section}`} value={section}>
                <ListItemText primary={section} />
              </MenuItem>
            ))}
          </Select>
        </Grid>

        {providersContents
          .sort((a, b) => a.sectionOrder - b.sectionOrder)
          .map((item, i) => {
            if (item.section === openEditModal.section) {
              if (item.category === 'video') {
                return (
                  <div className="marginZero">
                  <Card className={contentCard}>
                    <Grid container justifyContent="center">
                      <Grid className={fontAdjust}>
                        {`      Current order of the following video is ${
                          item.sectionOrder
                          }. Enter desired order:`}
                        <input
                          name="form1"
                          type="text"
                          sectionorder={item.sectionOrder}
                          data-idx={i}
                          id={item.id}
                          className="sectionorder"
                          onChange={e => handleOrderChange(e)}
                        />
                        <Button
                          color="primary"
                          size="small"
                          onClickSuccessSnackbar="Content was sucessfully updated."
                          onClickFailSnackbar="Content could not be updated"
                          onClick={updateOrder}
                        >
                          Show updated order
                        </Button>

                        <Button
                          color="secondary"
                          onClickSuccessSnackbar="Content deleted sucessfully."
                          onClickFailSnackbar="Content was not deleted."
                          onClick={() => {
                            onDelete(item.id);
                          }}
                        >
                          Delete
                        </Button>
                      </Grid>
                      <Grid className={innerPadding}>
                        <iframe
                          src={item.linkTo}
                          width="800"
                          height="400"
                          frameBorder="0"
                          allowFullScreen="allowFullScreen"
                        />
                      </Grid>
                    </Grid>
                  </Card>
                  </div>
                );
              } else if (item.category === 'image') {
                return (
                  <div className="marginZero">
                  <Card className={contentCard}>
                    <Grid container justifyContent="center">
                      <Grid className={fontAdjust}>
                        {`      Current order of the following image is ${
                          item.sectionOrder
                          }. Enter desired order:`}
                        <input
                          name="form1"
                          type="text"
                          sectionorder={item.sectionOrder}
                          data-idx={i}
                          id={item.id}
                          className="sectionorder"
                          onChange={e => handleOrderChange(e)}
                        />
                        <Button
                          onClickSuccessSnackbar="Content was sucessfully updated."
                          onClickFailSnackbar="Content could not be updated"
                          color="primary"
                          size="small"
                          onClick={updateOrder}
                        >
                          Show updated order
                        </Button>
                        <Button
                          onClickSuccessSnackbar="Content deleted sucessfully."
                          onClickFailSnackbar="Content was not deleted."
                          color="secondary"
                          onClick={() => {
                            onDelete(item.id);
                          }}
                        >
                          Delete
                        </Button>
                      </Grid>
                      <Grid className={innerPadding}>
                        <img
                          src={item.linkTo}
                          width="800"
                          height="400"
                          alt={item.description}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                  </div>
                );
              } else if (item.category === 'link') {
                if (item.category === 'link') {
                  return (
                    <div className="marginZero">
                    <Card className={contentCard}>
                      <Grid container justifyContent="center">
                        <Grid className={fontAdjust}>
                          {`      Current order of the following link is ${
                            item.sectionOrder
                            }.`}
                          <input
                            name="form1"
                            type="text"
                            sectionorder={item.sectionOrder}
                            data-idx={i}
                            id={item.id}
                            className="sectionorder"
                            onChange={e => handleOrderChange(e)}
                          />
                          <Button
                            onClickSuccessSnackbar="Content deleted sucessfully."
                            onClickFailSnackbar="Content was not deleted."
                            color="secondary"
                            onClick={() => {
                              onDelete(item.id);
                            }}
                          >
                            Delete
                          </Button>
                          <Button
                            onClickSuccessSnackbar="Content was sucessfully updated."
                            onClickFailSnackbar="Content could not be updated"
                            color="primary"
                            size="small"
                            onClick={updateOrder}
                          >
                            Show updated order
                          </Button>
                        </Grid>
                        <Grid className={innerPadding}>
                          <a href={item.linkTo}>{item.description}</a>
                        </Grid>
                      </Grid>
                    </Card>
                    </div>
                  );
                }
              } else {
                return (
                  <div className="marginZero">
                  <Card className={contentCard}>
                    <Grid container justifyContent="center">
                      <Grid className={fontAdjust}>
                        {`      Current order of the following text is ${
                          item.sectionOrder
                          }. Enter desired order:`}
                        <input
                          name="form1"
                          type="text"
                          sectionorder={item.sectionOrder}
                          data-idx={i}
                          id={item.id}
                          className="sectionorder"
                          onChange={e => handleOrderChange(e)}
                        />
                        <Button
                          onClickSuccessSnackbar="Content was sucessfully updated."
                          onClickFailSnackbar="Content could not be updated"
                          color="primary"
                          size="small"
                          onClick={updateOrder}
                        >
                          Show updated order
                        </Button>
                        <Button
                          onClickSuccessSnackbar="Content deleted sucessfully."
                          onClickFailSnackbar="Content was not deleted."
                          color="secondary"
                          onClick={() => {
                            onDelete(item.id);
                          }}
                        >
                          Delete
                        </Button>
                      </Grid>
                      <Grid item xs="12" className={innerPadding}>
                        {item.content || item.description}
                      </Grid>
                    </Grid>
                  </Card>
                  </div>
                );
              }
            }
          }) || null}

Videos are always displayed at the bottom of the About section.
You must click "Update All" to save your changes. Your changes will be lost if you skip this step.
        <Button
          onClickSuccessSnackbar="You have successfully updated all the content."
          onClickFailSnackbar="Content could not be updated."
          color="primary"
          variant="contained"
          justify="center"
          onClick={updateAll}
        >
          Update all
        </Button>
      </DialogContent>
    </Dialog>
  );
}

const styles = () => ({
  modal: { maxWidth: '1000px', background: '#f3f5f7' },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  contentCard: {
    margin: '1.5em',
    display: 'flex',
    justify: 'center',
  },
  innerPadding: {
    padding: '1.5em',
    display: 'flex',
    justify: 'center',
  },
  selectFormatting: {
    background: 'white',
  },
  fontAdjust: {
    padding: '1.5em 0 0 0 ',
  },
});

export default Backgroundscroll (withStyles(styles)(ProfileEditModal));
